import { __rest } from '../../../_virtual/_tslib.js';
import React from 'react';
import PropTypes from 'prop-types';
import a11yHelpers from '../../../helpers/a11y/a11y.js';

function InputInfo(_a) {
  var {
      id,
      className,
      children = '',
      error = false,
      srOnly = false
    } = _a,
    rest = __rest(_a, ["id", "className", "children", "error", "srOnly"]);
  const srOnlyHelper = srOnly ? a11yHelpers().srOnly : '';
  const idPrefix = error ? 'infoError-' : 'info-';
  const srOnlyPrefix = srOnly ? 'srOnly-' : '';
  const ariaLive = error ? {
    'aria-live': 'assertive',
    role: 'alert'
  } : {};
  return /*#__PURE__*/React.createElement("span", Object.assign({
    id: "".concat(idPrefix).concat(srOnlyPrefix).concat(id),
    className: "".concat(className, " ").concat(srOnlyHelper).trim()
  }, ariaLive, rest), children);
}
InputInfo.displayName = 'InputInfo';
const InputInfoChildren = PropTypes.node;
InputInfo.propTypes = {
  id: PropTypes.string.isRequired,
  className: PropTypes.string.isRequired,
  children: InputInfoChildren,
  error: PropTypes.bool,
  srOnly: PropTypes.bool
};

export { InputInfo, InputInfoChildren, InputInfo as default };
